module.exports = __webpack_public_path__ + "img/person-black-18dp.b65ed963.svg";